module.exports = __webpack_public_path__ + "img/long.44d54ddb.svg";